import React from 'react';
import { Alert, Card, Col, Row } from 'antd';
import PropTypes from 'prop-types';

import FormInput from 'components/FormInput/FormInput';

import styles from './TermsAndConditionsCard.module.css';
import intl from 'react-intl-universal';

const TermsAndConditionsCard = ({ form, cardClassname, defaultValues }) => {
  return (
    <Card title={intl.get('listings.property.headerLabels.termsAndConditionsInfo').d('Terms and Conditions')} className={cardClassname}>
      <Row gutter={16}>
        <Col span={24}>
          <Alert
            className={styles.notes}
            message={intl.get('listings.property.headerLabels.info').d('Information')}
            description={
              <div>
                <p className={styles.notesText}>
                  {intl
                    .get('listings.property.headerLabels.termsAndConditionsDesc')
                    .d(
                      'These terms and conditions will be displayed on the registration ticket and deposit receipt features respectively. These fields are optional and apply to all units under this property. This is different from the fine print on the individual unit level.'
                    )}
                </p>
              </div>
            }
            type="info"
            showIcon
          />
          <br />
          <FormInput
            form={form}
            name="registrationTicketTermsAndConditions"
            defaultValue={defaultValues.registrationTicketTermsAndConditions}
            inputType="textarea"
            label={intl
              .get('listings.property.headerLabels.registrationTicketTermsAndConditions')
              .d('Registration Ticket - Terms and Conditions (Optional)')}
            placeholder={intl
              .get('listings.property.placeholder.registrationTicketTermsAndConditions')
              .d('Enter your terms and conditions for registration tickets')}
            extraProps={{ rows: 6 }}
          />
          <br />
          <FormInput
            form={form}
            name="depositReceiptTermsAndConditions"
            defaultValue={defaultValues.depositReceiptTermsAndConditions}
            inputType="textarea"
            label={intl.get('listings.property.headerLabels.depositReceiptTermsAndConditions').d('Deposit Receipt - Terms and Conditions (Optional)')}
            placeholder={intl
              .get('listings.property.placeholder.depositReceiptTermsAndConditions')
              .d('Enter your terms and conditions for deposit receipts')}
            extraProps={{ rows: 6 }}
          />
        </Col>
      </Row>
    </Card>
  );
};

TermsAndConditionsCard.propTypes = {
  form: PropTypes.object.isRequired,
  cardClassname: PropTypes.string.isRequired,
  defaultValues: PropTypes.object
};

TermsAndConditionsCard.defaultProps = {
  defaultValues: {}
};

export default TermsAndConditionsCard;
